import Contact from '@components/contact/contact';
import PageTitleBar from '@components/layout/page-title-bar/page-title-bar';
import { CardRow } from '@components/elements/card/card';
import { v2_fetchBranchesFallback, v2_useBranches } from '@crocodille/common';
import { getDayOfWeek } from '@crocodille/util';
import { AppPage } from '@framework/page';
import { getAboutLayout } from '@layouts/about-layout/about-layout';
import ContactForm from '@sections/contact/contact-form';
import { getApp } from '@utils/app';
import { getServerSideTranslationProps } from '@utils/i18n';
import { GetServerSideProps } from 'next';
import { useTranslation } from 'react-i18next';
import RestaurantCard from '@components/restaurants/restaurant-card/restaurant-card';

export interface ContactPageProps {
  readonly fallback: Record<string, unknown>;
}

const ContactPage: AppPage<ContactPageProps> = () => {
  const { t } = useTranslation(['common', 'contact', 'restaurants']);
  const { data: branches } = v2_useBranches();
  const today = getDayOfWeek(new Date());

  return (
    <>
      <PageTitleBar title={t('common:contact.title')} />
      <Contact />
      <PageTitleBar title={t('contact:form.title')} />
      <ContactForm />
      <PageTitleBar title={t('restaurants:page_title')} />
      <CardRow>
        {branches?.map((branch) => (
          <RestaurantCard
            key={branch.code}
            name={branch.name}
            imageSrc={branch.imagePath}
            address={branch.address}
            openFrom={branch.openingHours[today]?.openFrom}
            openTo={branch.openingHours[today]?.openTo}
            deliveryFrom={branch.openingHours[today]?.deliveryFrom}
            deliveryTo={branch.openingHours[today]?.deliveryTo}
            small={true}
            code={branch.code}
          />
        ))}
      </CardRow>
    </>
  );
};

ContactPage.getLayout = (page, pageProps) => {
  return getAboutLayout(page, pageProps.fallback);
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const app = getApp(ctx);

  const [translationProps, branchesFallback] = await Promise.all([
    getServerSideTranslationProps(app, ['common', 'contact', 'restaurants']),
    v2_fetchBranchesFallback(app),
  ]);

  return {
    props: {
      ...translationProps,
      fallback: { ...branchesFallback },
    },
  };
};

export default ContactPage;
